<div [formGroup]="form">

  <div class="date-from">
    <label for="dfrom">Date from <span [ngStyle]="{'color': 'maroon'}">(required)</span></label>
    <!--<input type="text" id="dfrom" name="datefrom" placeholder="mm-dd-yyyy" [(ngModel)]="utilityobj.fromDate">-->
    <dx-date-box id="dfrom"
                 placeholder="mm/dd/yyyy"
                 [useMaskBehavior]="true"
                 [showClearButton]="true"
                 [showDropDownButton]="false"
                 displayFormat="shortdate"
                 type="date"
                 name="datefrom"
                 format="MM/dd/YYYY"
                 formControlName="datefrom"
                 [(value)]="utilityobj.fromDate">
      <dxi-button name="clear"></dxi-button>
      <dx-validator>
        <dxi-validation-rule type="required"></dxi-validation-rule>
      </dx-validator>
    </dx-date-box>
    <div class="help-block">
      <span *ngIf="form.get('datefrom').errors?.required && form.get('datefrom').touched">Enter Date from; use mm/dd/yyyy format</span>
      <span *ngIf="form.errors?.fromdatefuture && form.get('datefrom').touched">Date from cannot be future date</span>
    </div>
  </div>
  <div class="space"></div>
  <div class="date-to">
    <label for="dto">Through date <span [ngStyle]="{'color': 'maroon'}">(required)</span></label>
    <!--<input type="text" id="dto" name="dateto" placeholder="mm-dd-yyyy" [(ngModel)]="utilityobj.toDate">-->
    <dx-date-box id="dto"
                 placeholder="mm/dd/yyyy"
                 [useMaskBehavior]="true"
                 [showClearButton]="true"
                 [showDropDownButton]="false"
                 displayFormat="shortdate"
                 format="MM/dd/YYYY"
                 type="date"
                 name="dateto"
                 formControlName="dateto"
                 [(value)]="utilityobj.toDate">
      <dxi-button name="clear"></dxi-button>
      <dx-validator>
        <dxi-validation-rule type="required"></dxi-validation-rule>
      </dx-validator>

    </dx-date-box>
    <div class="help-block">
      <span *ngIf="form.get('dateto').errors?.required && form.get('dateto').touched">Enter Date to; use mm/dd/yyyy format</span>
      <span *ngIf="form.errors?.datecompare && form.get('dateto').touched">Date from cannot be greater than through date</span>
      <!--<span class="help-block"
      *ngIf="form.errors?.todatefuture && form.get('dateto').touched">Date to is future date.</span>-->
    </div>
  </div>
</div>
